export enum EFooterLinks {
  LICENSE_AGREEMENT = "license-agreement",
  SAAS_AGREEMENT = "saas-agreement",
  PRIVACY = "privacy",
  TERMS_OF_USE = "term-of-use",
}
